import React from 'react';
import './TipSelector.css';

const TipSelector = ({ tipPercentage, onTipChange }) => {
  const tipOptions = [
    { value: 0, label: '0%' },
    { value: 0.10, label: '10%' },
    { value: 0.15, label: '15%' },
    { value: 0.20, label: '20%' },
    { value: 0.25, label: '25%' }
  ];

  return (
    <div className="tip-selector">
      <h3>Agregar Tip</h3>
      
      <div className="tip-options">
        {tipOptions.map(option => (
          <button
            key={option.value}
            className={`tip-option ${tipPercentage === option.value ? 'active' : ''}`}
            onClick={() => onTipChange(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
      
      <div className="custom-tip">
        <input
          type="number"
          min="0"
          max="100"
          step="1"
          placeholder="Custom %"
          value={tipPercentage === Math.round(tipPercentage * 100) / 100 ? '' : tipPercentage * 100}
          onChange={(e) => {
            const value = parseFloat(e.target.value);
            if (!isNaN(value) && value >= 0 && value <= 100) {
              onTipChange(value / 100);
            }
          }}
          className="custom-tip-input"
        />
        <span className="percent-symbol">%</span>
      </div>
    </div>
  );
};

export default TipSelector;